import { AccordionDetails, Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    checkVPA,
    createPaymentRequestData,
} from '../../redux/actions/ComponentCallsActions'
import { EncKeys, MicroservicesBaseUrl } from '../../../config'
import CryptoJS from 'crypto-js'
import { alertService } from '../../services/alert-service'
import axios from 'axios'

const JioPayUPI = (props) => {
    const paymentData = useSelector((state) => state.customerData)
    const [UpiId, setUpiId] = useState('')
    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    const dispatch = useDispatch()
    const history = useHistory()

    const handleBack = () => {
        props.onBackBtnClick()
    }
    const handleChange = ({ target: { name, value } }) => {
        setUpiId(value)
    }

    const SubmitRequest = () => {
                            const postRequest = {
                                CustomerPaymentReqID:
                                    paymentData.customerData.PaymentRequest.Id,
                                AgentID:
                                    paymentData.customerData.PaymentRequest
                                        .ClientId,
                                PaymentOption: 'JioPayUPI',
                                TrackId:
                                    paymentData.customerData.PaymentRequest
                                        .TrackID,
                                TotalAmount:
                                    paymentData.customerData.PaymentRequest
                                        .Amount,
                                Cvv: '',
                                ExpiryMonth: '',
                                ExpiryYear: '',
                                CardHolderName: '',
                                CardNo: '',
                                UDF1: paymentData.customerData.PaymentRequest
                                    .UDF1,
                                UDF2: paymentData.customerData.PaymentRequest
                                    .UDF2,
                                UDF3: paymentData.customerData.PaymentRequest
                                    .UDF3,
                                UDF4: paymentData.customerData.PaymentRequest
                                    .UDF4,
                                UDF5: paymentData.customerData.PaymentRequest
                                    .UDF5,
                                Email: '',
                                Contact: '',
                                TokenId: '',
                                IsCardDetailSaved: false,
                                IsNewCardDetailSave: false,
                                VirtualAddress: UpiId,
                            }

                            const jsonBody = JSON.stringify(postRequest)

                            let encryptedPostRequest = CryptoJS.AES.encrypt(
                                CryptoJS.enc.Utf8.parse(jsonBody.toString()),
                                key,
                                {
                                    keySize: 128 / 8,
                                    iv: iv,
                                    mode: CryptoJS.mode.CBC,
                                    padding: CryptoJS.pad.Pkcs7,
                                }
                            )

                            let postData = {
                                payload: encryptedPostRequest.toString(),
                            }

                            dispatch(
                                createPaymentRequestData(
                                    postData,
                                    (res) => {
                                        if (res.statusCode === 200) {
                                              const decryptedResponse = CryptoJS.AES.decrypt(
                                                                            res.data,
                                                                            key,
                                                                            {
                                                                                keySize: 128 / 8,
                                                                                iv: iv,
                                                                                mode: CryptoJS.mode.CBC,
                                                                                padding: CryptoJS.pad.Pkcs7,
                                                                            }
                                                                        )
                                                                        const decrypted = decryptedResponse.toString(
                                                                            CryptoJS.enc.Utf8
                                                                        )
                                                                        let actualResponse = JSON.parse(decrypted)
                                                                        localStorage.setItem('gateway', 'JioPayUPI')
window.location.replace(actualResponse)
                                                                    } else {
                                            alertService.addError(res?.errorMessage);
                                            // const transactionResponse = {
                                            //     Comments: res.errorMessage,
                                            //     Status: 'Transaction declined',
                                            //     TransactionId: '',
                                            //     TrackId: '',
                                            //     Amount: '',
                                            //     TransactionDate: '',
                                            //     RedirectUrl:
                                            //         paymentData.customerData
                                            //             .PaymentRequest
                                            //             .RedirectUrl,
                                            // }
                                            // history.push({
                                            //     pathname: '/TransactionStatus',
                                            //     state: transactionResponse,
                                            // })
                                        }
                                    },
                                    (err) => {
                                          const msg =
                                            err?.response?.data?.errorMessage ||
                                            err?.response?.data?.message ||
                                            err?.message ||
                                            'Request failed';
                                        
                                          alertService.addError(msg); 
                                        // const transactionResponse = {
                                        //     Comments:
                                        //         'Please Contact Vayana Team for further details',
                                        //     Status: 'Transaction declined',
                                        //     TransactionId: '',
                                        //     TrackId: '',
                                        //     Amount: '',
                                        //     TransactionDate: '',
                                        //     RedirectUrl:
                                        //         paymentData.customerData
                                        //             .PaymentRequest.RedirectUrl,
                                        // }
                                        // history.push({
                                        //     pathname: '/TransactionStatus',
                                        //     state: transactionResponse,
                                        // })
                                    }
                                )
                            )
    }



async function getCalculationData() {
  const postRequest = {
    PaymentOption: 'JioPayUPI',
    TrackId: paymentData.customerData.PaymentRequest.TrackID,
  }

  const jsonBody = JSON.stringify(postRequest)

  const encryptedPostRequest = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(jsonBody),
    key,
    {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  )

  const postData = { payload: encryptedPostRequest.toString() }

  try {
        const url = `${MicroservicesBaseUrl.baseApiUrl}api/banking/CalculateTransactionCharges`

    // console.log('calling URL:', url)

    const { data: result } = await axios.post(url, postData)

    // console.log('charges raw result', result)

    if (result.statusCode === 200 && result.data) {
      const decryptedResponse = CryptoJS.AES.decrypt(
        result.data,
        key,
        {
          keySize: 128 / 8,
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      )

      const decrypted = decryptedResponse.toString(CryptoJS.enc.Utf8)
      const actualResponse = JSON.parse(decrypted)

    //   console.log('charges decrypted', actualResponse)
      props.setCharges(actualResponse)
      // set local state here if needed
    } else {
    //   console.log('charges non-200', result)
    }
  } catch (err) {
    // console.log('charges error', err)
  }
}

useEffect(() => {
getCalculationData();
}, [])

    return (
        <div>
            <ValidatorForm onSubmit={SubmitRequest}>
                <AccordionDetails
                    style={{
                        margin: '10px 0px',
                    }}
                >
                    <Typography
                        style={{
                            paddingBottom: '10px',
                        }}
                    >
                        Enter UPI ID
                    </Typography>
                    <br />
                    <TextValidator
                        size="small"
                        id="Outlined-basic"
                        variant="outlined"
                        label="UPI ID"
                        color="primary"
                        fullWidth
                        autoComplete="off"
                        placeholder="UPI ID"
                        value={UpiId || ''}
                        onChange={handleChange}
                        validators={['required']}
                        errorMessages={['UPI ID is required']}
                        FormHelperTextProps={{
                            color: 'red',
                        }}
                    />

                    <br />
                    <br />
                    <br />
                    <br />
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <button
                                onClick={handleBack}
                                className="backButton"
                                style={{
                                    width: '100%',
                                    padding: '15px',
                                    fontSize: '15px',
                                }}
                            >
                                Back
                            </button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                                {props.acceptCharges===false? 
                                                                <button
                                                                disabled={props.acceptCharges===false?true : false}
                                    className="btn"
                                    style={{
backgroundColor:
                                            paymentData.customerData
                                                .UIConfig
                                                .ButtonBackgroundColor,
                                        color: paymentData.customerData
                                            .UIConfig.ButtonTextColor,
                                            opacity:"0.5"
                                    }}
                                >
                                    Pay
                                </button>
                                : 
                                                                <button
                                    className="btn"
                                    style={{
                                        backgroundColor:
                                            paymentData.customerData
                                                .UIConfig
                                                .ButtonBackgroundColor,
                                        color: paymentData.customerData
                                            .UIConfig.ButtonTextColor,
                                    }}
                                >
                                    Pay
                                </button>}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </ValidatorForm>
        </div>
    )
}

export default JioPayUPI